"use client"

import { FormEvent, useState } from "react"
import emailjs from "@emailjs/browser"

type TrackData = {
  file?: File | null
  image?: File | string | null
  title: string
  artist: string
  genre: string
}

type Props = {
  trackData: TrackData
}

export default function Enviar({
  trackData,
}: Props) {
  const [enviado, setEnviado] =
    useState(false)

  const [enviando, setEnviando] =
    useState(false)

  const SERVICE_ID =
    "service_vzbjbyg"

  const TEMPLATE_ID =
    "template_xgajxwb"

  const PUBLIC_KEY =
    "1qs6eWKjTREDlPlKf"

  const handleEnviar = async (
    e: FormEvent<HTMLFormElement>
  ) => {
    e.preventDefault()

    setEnviando(true)

    try {
      const templateParams = {
        title:
          trackData.title ||
          "Sin título",

        artist:
          trackData.artist ||
          "Desconocido",

        genre:
          trackData.genre ||
          "No definido",
      }

      await emailjs.send(
        SERVICE_ID,
        TEMPLATE_ID,
        templateParams,
        PUBLIC_KEY
      )

      setEnviado(true)
    } catch (error) {
      console.error(error)

      alert(
        "Ha ocurrido un error al enviar."
      )
    } finally {
      setEnviando(false)
    }
  }

  // ==========================
  // SUCCESS
  // ==========================

  if (enviado) {
    return (
      <div
        className="
          overflow-hidden
          rounded-xl
          bg-[#141414]

          landscape:h-[30rem]
        "
      >
        <video
          autoPlay
          muted
          className="
            h-[20rem]
            w-full
            rounded-xl
            object-cover

            landscape:h-full
          "
          onEnded={() =>
            console.log(
              "Video finalizado"
            )
          }
        >
          <source
            src="./assets/videos/subir.mp4"
            type="video/mp4"
          />
        </video>
      </div>
    )
  }

    return (
    <div
      className="
        mx-auto

        rounded-2xl

        bg-[#333333]

        p-8

        text-[0.85rem]

        landscape:grid
        landscape:grid-cols-2
        landscape:gap-8

        standalone:mb-20
      "
    >
      {/* PREVIEW */}
      <div
        className="
          mb-4

          rounded-lg

          bg-[#222]

          p-4

          landscape:mb-0
        "
      >
        {trackData.image && (
          <img
            src={
              typeof trackData.image === "string"
                ? trackData.image
                : URL.createObjectURL(trackData.image)
            }
            alt="Preview"
            className="
              w-full

              max-h-[22rem]

              rounded-lg

              object-cover
            "
          />
        )}
      </div>

      {/* FORM */}
      <form
        onSubmit={handleEnviar}
        className="
          flex
          flex-col
          gap-4
        "
      >
        <h2
          className="
            text-2xl
            font-bold
            text-white
          "
        >
          Subir pista
        </h2>

        <div className="space-y-2 text-white/80">
          <p>
            <strong>Título:</strong>{" "}
            {trackData.title}
          </p>

          <p>
            <strong>Artista:</strong>{" "}
            {trackData.artist}
          </p>

          <p>
            <strong>Género:</strong>{" "}
            {trackData.genre}
          </p>
        </div>

        <button
          type="submit"
          disabled={enviando}
          className="
            mt-4

            rounded-xl

            bg-black

            px-6
            py-3

            font-bold

            text-white

            transition-all

            hover:bg-[#222]

            disabled:pointer-events-none
            disabled:opacity-60
          "
        >
          {enviando
            ? "Enviando..."
            : "Enviar"}
        </button>
      </form>
    </div>
  )
}